import {
  AddOn,
  QueryAddOnsResponse,
} from '@wix/ambassador-addons-v1-add-on/types';
import { MultiAddonsInfo } from '@wix/bookings-uou-types';
import { FormNestedSlot } from '../../../types/formSelectedSlots';
import { FormService } from '../../mappers/serviceMapper/service.mapper';
import { areDatesEqual } from '../../time';
import { SelectedAddons } from '../types';

export const initiateSelectedAddonsState = ({
  addonsInfoPreSelection,
  service,
  preSelectedAddons,
  slot,
}: {
  addonsInfoPreSelection?: MultiAddonsInfo[];
  service: FormService;
  preSelectedAddons?: QueryAddOnsResponse;
  slot: FormNestedSlot;
}): SelectedAddons | undefined => {
  if (!addonsInfoPreSelection?.length || !preSelectedAddons?.addOns?.length) {
    return undefined;
  }

  const serviceAddonsInfo = addonsInfoPreSelection.find(
    (info) =>
      info.serviceId === service.id &&
      areDatesEqual(info.startDate, slot.startDate),
  );

  if (!serviceAddonsInfo) {
    return undefined;
  }

  return serviceAddonsInfo.addonsInfo.reduce<SelectedAddons>(
    (acc, groupInfo) => {
      const groupId = groupInfo.groupId;
      if (!acc[groupId]) {
        acc[groupId] = {};
      }

      groupInfo.addons.forEach((addon) => {
        const preSelectedAddon = preSelectedAddons.addOns?.find(
          (preSelected: AddOn) => preSelected.id === addon.id,
        );

        if (preSelectedAddon) {
          acc[groupId][addon.id] = {
            id: addon.id,
            quantity: addon.quantity,
            price: preSelectedAddon.price?.value,
            currency: preSelectedAddon.price?.currency || 'USD',
            durationInMinutes: preSelectedAddon.durationInMinutes,
          };
        }
      });
      return acc;
    },
    {},
  );
};
